const Fetcher = require('od-modules/utils/fetcher');
const PATH = 'dynpack/shopping-cart/id-validation';
const URL_SERVICE = `${Odigeo.Settings.property('appContext')}/service/${PATH}`;
const EVENT_NAMESPACE = 'visibilitychange.checkSearchIsValid';
const TRACKING_ACTION = 'multitab';
const TRACKING_LABEL_PREFIX = 'tab_deactivated_popup';
let paramsToCheck = {};

const $document = $(document);

const getTrackingLabel = (label) => {
    const trackingLabelPage = Odigeo.History.getPageNameFromFragment();
    const pageParam = trackingLabelPage ? `_pag:${trackingLabelPage}` : '';

    return `${TRACKING_LABEL_PREFIX}_${label}${pageParam}`;
};

const setParamsToCheck = (searchId, bookingId) => {
    paramsToCheck = Object.assign({},
        (searchId) ? {searchId: searchId} : null,
        (bookingId) ? {bookingId: bookingId} : null,
    );
};

const convertParamsToSearchValidCall = (params) => Object.entries(params)
    .reduce((result, [key, value], index) => result + `${index === 0 ? '?' : '&'}${key}=${value}`, '') || '';

const onSuccessValidSearch = (data) => {
    if (Object.values(data).includes(false)) {
        showRecoverTripModal();
    }
};

const onErrorValidSearch = () => {
    showRecoverTripModal();
};

const checkSearchIsValid = () => {
    if (document.visibilityState === 'visible') {
        const paramsForURL = convertParamsToSearchValidCall(paramsToCheck);

        return Fetcher.get(URL_SERVICE + paramsForURL).json()
            .then(onSuccessValidSearch, onErrorValidSearch);
    }
};

const showRecoverTripModal = () => {
    Odigeo.UIElements.showDynpackSessionExpiredError({
        dataTracking: {
            show: {action: TRACKING_ACTION, label: getTrackingLabel('onload')},
            back: {action: TRACKING_ACTION, label: getTrackingLabel('newsearch')},
            retryDynpackDeeplink: {action: TRACKING_ACTION, label: getTrackingLabel('recoversearch')},
            phone: {action: TRACKING_ACTION, label: getTrackingLabel('call_us')},
        },
    });

    $document.off(EVENT_NAMESPACE);
};

module.exports = {
    setTabFocusEvent: (shouldListenFocusEvent, searchId, bookingId) => {
        if (shouldListenFocusEvent) {
            $document.off(EVENT_NAMESPACE);
            $document.on(EVENT_NAMESPACE, checkSearchIsValid);
            Odigeo.once('routeChange', () => $document.off(EVENT_NAMESPACE));
            setParamsToCheck(searchId, bookingId);
        } else {
            $document.off(EVENT_NAMESPACE);
        }
    },

    checkSearchIsValid: (searchId, bookingId) => {
        setParamsToCheck(searchId, bookingId);
        checkSearchIsValid();
    },
};
